export const FETCH_DIVISION_LIST_REQUEST = 'FETCH_DIVISION_LIST_REQUEST';
export const FETCH_DIVISION_LIST_SUCCESS = 'FETCH_DIVISION_LIST_SUCCESS';
export const FETCH_DIVISION_LIST_FAILURE = 'FETCH_DIVISION_LIST_FAILURE';
export const CLEAR_DIVISION_LIST = 'CLEAR_DIVISION_LIST';
